import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`A Call for Feedback`}</h1>
    <p>{`Congratulations - you've reached the end of the course! `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "partying face"
      }}>{`🥳`}</span></p>
    <p>{`As you might have noticed - this course (and this platform) is in beta. It's just getting started,
and we know we can make it better.`}</p>
    <p>{`As one of the first few students to complete the course, we'd really like to hear about your
experience - what worked, what didn't work, and what we should improve.`}</p>
    <h2>{`Ways to give feedback`}</h2>
    <p>{`As you've (hopefully) seen before: there's a `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://discord.gg/SuXwAxNQrs"
        }}>{`Discord group`}</a></strong>{`
where students and staff can discuss the course. The
`}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://discord.gg/SuXwAxNQrs"
        }}>{`#feedback channel`}</a></strong>{` is open for your ideas and suggestions!`}</p>
    <p>{`At the bottom of every page in the course, there's a `}<strong parentName="p">{`comment section`}</strong>{`. We (the team behind this
course) get notified when there's a new comment, so you can leave feedback directly on the page.
This is particularly helpful when there's a specific issue with that page, but we'll see any general
feedback left there too!`}</p>
    <p>{`If you're willing, we also have a more in-depth `}<strong parentName="p"><a parentName="strong" {...{
          "href": "make.sc/beta-feedback"
        }}>{`Course Survey`}</a></strong>{`. It takes
10-15 minutes, and asks all about the course.`}</p>
    <p>{`Finally, we'd like to meet you!
`}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://calendly.com/course-feedback/30min"
        }}>{`Schedule time to meet with one of the course architects with Calendly`}</a></strong>{`.
We do meetings over Zoom, and would love to hear your thoughts about the course or answer lingering
questions you have.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      